import { createStore } from "vuex";
import adminModule from "@/apps/admin-console/store/admin.module";

export const store = createStore({
  modules: {
    admin: adminModule,
  },
});

export default store;
